import * as CryptoJS from 'crypto-js';
import { configData } from '../../environments/configData';
import { MatSnackBar } from '@angular/material/snack-bar';

export function encryptData(data: string): string {
    return CryptoJS.AES.encrypt(data, configData.SECRET_KEY).toString();
}

export function showNotification(
    snackBar: MatSnackBar,
    text: string,
    colorName: string
) {
    snackBar.open(text, '', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: colorName == 'success' ? 'snackbar-success' : 'snackbar-danger',
    });
}

export function getFormattedDateShort(epochDate: number, locale: string): string {
    const date = new Date(epochDate);  // Unix timestamp to Date object
    const formattedDate = new Intl.DateTimeFormat(locale, {
        year: 'numeric',  // Full year (e.g., "2025")
        month: 'long',    // Full month name 
        day: 'numeric',   // Day of the month (e.g., "31")
    }).format(date);
    return formattedDate.toLocaleUpperCase();
}

export function formatPhoneNumber(str: any) {
    //Filter only numbers from the input
    const cleaned = ('' + str).replace(/\D/g, '');
    //Check if the input is of correct length
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return '';
}

export function formatUSD(amount: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
}


export function longDate(date_tmp_: any) {
    let date = new Date(date_tmp_);
    let day = configData.WEEK_ARRAY[date.getDay()];
    let month = configData.MONTH_NAME[date.getMonth()];
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var time_notation = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var minutes_ = minutes < 10 ? "0" + minutes : minutes;
    let fullname =
        day +
        "," +
        month +
        " " +
        date.getDate() +
        ", " +
        date.getFullYear() +
        " " +
        ("0" + hours).slice(-2) +
        ":" +
        ("0" + minutes_).slice(-2) +
        " " +
        time_notation;

    return fullname;
}